import type { ReactNode } from 'react';
import s from './ToolName.module.css';

/**
 * Como T5, T7 e T10 mostram uma tool (aim-92c, decisão do mrolim de 08/10):
 *
 * - o Display name do gateway em **destaque**, e embaixo, menor e em `mono`, o nome
 *   técnico — o nome no PDP, «para conferência técnica»;
 * - sem Display name, só o nome técnico, em destaque;
 * - **sempre os dois** quando há Display name, mesmo iguais (D5): a API antiga `api`
 *   repete o nome nas duas linhas, e a tela não decide por quem lê qual dos dois vale;
 * - o que acompanha a tool (risco, limites, o detalhe do diff) fica na linha do destaque,
 *   em `trailing`.
 *
 * Um componente só, para as três telas dizerem a mesma coisa da mesma tool. As
 * marcas de `data-testid` são o que os testes consultam — a estrutura, nunca a frase.
 */
export interface ToolNameProps {
  /** O Display name do gateway; vazio ou nulo quando ele não tem. */
  displayName?: string | null;
  /** O nome técnico: o nome da tool (T5, T7) ou o par `<apim_id>/<tool>` (T10). */
  technicalName: string;
  /** O que vai na linha do destaque, depois do nome. */
  trailing?: ReactNode;
}

export function ToolName({ displayName, technicalName, trailing }: ToolNameProps) {
  const display = displayName?.trim() ? displayName : null;
  return (
    <span className={s.toolName} data-testid="tool-name">
      <span className={s.line}>
        <span
          className={display ? s.primary : `${s.primary} ${s.primaryTechnical}`}
          data-testid="tool-name-primary"
        >
          {display ?? technicalName}
        </span>
        {trailing}
      </span>
      {display ? (
        <span className={s.technical} data-testid="tool-name-technical">
          {technicalName}
        </span>
      ) : null}
    </span>
  );
}
